import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { Fab, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LayoutFor } from '../../types'

const DamageRegistrationFab = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'isFabForInRoute',
})(({ theme, isFabForInRoute }) => ({
  backgroundColor: '#fff',
  width: 132,
  position: 'fixed',
  right: 16,
  bottom: 80,
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(2.875),
  boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.24)',
  '& span': { letterSpacing: '1.25px' },
  ...(isFabForInRoute && {
    bottom: 16,
  }),
}))

const DamageRegistrationButtonLabel = styled('span')(() => ({
  textAlign: 'center',
  textTransform: 'uppercase',
}))

export default function DamageRegistrationBtn({ handleClick, layoutFor }) {
  const { t } = useTranslation()

  return (
    <DamageRegistrationFab
      variant="extended"
      onClick={handleClick}
      isFabForInRoute={layoutFor === LayoutFor.IN_ROUTE}
    >
      <AddIcon />
      <DamageRegistrationButtonLabel>
        {t('common.damage')}
      </DamageRegistrationButtonLabel>
    </DamageRegistrationFab>
  )
}
